/**
 * Styled-components theme for Reassure-UI button components
 */
import { lighten } from 'polished';
import pallette from './pallette';

type ButtonTheme = {
    colors: {
        button: {
            primary: {
                text: string;
                background: string;
                border: string;
                hover: {
                    text: string;
                    background: string;
                    border: string;
                };
                disabled: {
                    text: string;
                    background: string;
                    border: string;
                };
            };
            secondary: {
                text: string;
                background: string;
                border: string;
                hover: {
                    text: string;
                    background: string;
                    border: string;
                };
                disabled: {
                    text: string;
                    background: string;
                    border: string;
                };
            };
        };
    };
};

const { transparent, white, lightBlue, darkBlue, midGreen } = pallette;

const button: ButtonTheme = {
    colors: {
        button: {
            primary: {
                text: white,
                background: midGreen,
                border: midGreen,
                hover: {
                    text: white,
                    background: lighten(0.04, midGreen),
                    border: lighten(0.04, midGreen),
                },
                disabled: {
                    text: lightBlue,
                    background: darkBlue,
                    border: darkBlue,
                },
            },
            secondary: {
                text: white,
                background: transparent,
                border: midGreen,
                hover: {
                    text: white,
                    background: transparent,
                    border: lighten(0.05, midGreen),
                },
                disabled: {
                    text: lightBlue,
                    background: transparent,
                    border: darkBlue,
                },
            },
        },
    },
};

export default button;
